export const branding = {
  BRANDING: 'branding/paywall',
  BRANDING_ID: 'branding/paywall/{id}',
  FETCH_THEMES: 'branding/paywall/{tenantUuid}',
  FETCH_THEME: `branding/paywall/{tenantUuid}/{id}?rnd=${Math.random() * 15}`,
  PAYWALL_COVER: 'images/paywall-cover-photo',
  PAYWALL_LOGO: 'images/paywall-brand-logo',
};
